import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {LayoutService} from '../layout/layout.service';
import {UIError} from './uierror';
import {ErrorService} from './error.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private router: Router = null;
  private layoutService: LayoutService = null;

  constructor(
    private injector: Injector,
    private errorService: ErrorService,
  ) {}

  handleError(error) {
    //report error
    if (status in error) {
      console.error(error.status);
    } else {
      console.error(error);
    }
    let code = error.name;
    if (status in error) code = error.status;
    this.errorService.reportError(new UIError(error.name, code, error.message, 'Global'));

    //show error message
    if (!this.router) this.router = this.injector.get(Router);
    if (!this.layoutService) this.layoutService = this.injector.get(LayoutService);

    if (error.status === 401 || error.status === 400) {
      this.layoutService.updateLoadingState('identitydirector');
      this.router.navigate(['/401']);
    } else {
      this.layoutService.updateLoadingState('identitydirector');
      this.router.navigate(['/500']);
    }
  }
}
